import { render, staticRenderFns } from "./WaybillSidebarReview.vue?vue&type=template&id=06de210e&"
import script from "./WaybillSidebarReview.vue?vue&type=script&lang=js&"
export * from "./WaybillSidebarReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports